@if (hasRoiPerOutputFeatureFlag) {
  <mat-button-toggle-group
    [nasModel]="cameraRoiDistanceStore('useForAllCameras')"
    [disabled]="isSplitViewDisabled$ | async"
  >
    <mat-button-toggle [value]="true">All cameras</mat-button-toggle>
    <mat-button-toggle [value]="false">Per camera</mat-button-toggle>
  </mat-button-toggle-group>
}

@if (
  (cameraRoiDistanceStore('useForAllCameras').$ | async) ||
  !hasRoiPerOutputFeatureFlag
) {
  <h3-numeric-input-settings
    [defaultValue]="defaultValue"
    label="Max distance"
    [settingStore]="cameraRoiDistanceStore('distanceForAlCameras')"
    [trackingEvent]="trackingEvent"
    [min]="1"
    [step]="0.1"
  ></h3-numeric-input-settings>
} @else {
  @for (output of videoOutputs; track $index) {
    <h3-numeric-input-settings
      [defaultValue]="defaultValue"
      [label]="output.name + ' - Max distance'"
      [settingStore]="cameraRoiDistanceStore('distancePerCamera')(output.name)"
      [trackingEvent]="trackingEvent"
      [min]="1"
      [step]="0.1"
    ></h3-numeric-input-settings>
  }
}
